export default "__VITE_ASSET__CMgOpSq0__"